<template>
	<div class="grid-flex-container mx-2">
		<v-container fluid class="py-6">
			<v-row class="mb-6">
				<div style="flex-grow: 1">
					<v-text-field
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div>
					<v-btn color="primary" @click="addClient()">
						<v-icon> mdi-plus</v-icon>
						&nbsp;&nbsp;Add
					</v-btn>
				</div>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				:headers="headers"
				:items="items"
				:search.sync="search"
				:sort-desc="[true]"
				:loading="loading"
				:disable-pagination="true"
				hide-default-footer
				loading-text="Loading..."
				fixed-header
				multi-sort
				dense
			>
				<template v-slot:[`item.LoginMethod`]="{ item }">
					{{ getLoginMethods(item) }}
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<div class="d-flex">
						<v-spacer />
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="success"
							@click="editClient(item)"
						>
							<v-icon small> mdi-pencil </v-icon>
						</v-btn>
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="error"
							@click="deleteClient(item.Id)"
						>
							<v-icon small> mdi-delete</v-icon>
						</v-btn>
					</div>
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { mapGetters } from 'vuex';
import { ClientManagementActions } from '../../store/actions';
import { ClientManagementGetters } from '../../store/getters';

export default {
	name: 'ClientsManagementList',
	components: {},
	data() {
		return {
			showDialog: false,
			headers: [
				{
					text: 'Name',
					value: 'Name',
				},
				{
					text: 'Description',
					value: 'Description',
				},
				{
					text: 'Client Access URL',
					value: 'Host',
				},
				{
					text: 'Login Method',
					value: 'LoginMethod',
				},
				{
					sortable: false,
					text: '',
					value: 'actions',
				},
			],
			search: '',
		};
	},

	computed: {
		...mapGetters({
			items: [ClientManagementGetters.GET_DATA],
			loading: [ClientManagementGetters.GRID_LOADING],
		}),
	},

	mounted() {
		this.getClients();
	},
	destroyed() {
		this.$store.dispatch(ClientManagementActions.CLEAR);
	},
	methods: {
		getClients() {
			this.$store.dispatch(ClientManagementActions.LOAD_DATA);
		},
		getLoginMethods(item) {
			switch (item.LoginMethod) {
				case 1:
					return 'Forms';
				case 2:
					return 'Windows';
				case 3:
					return 'SingleSignOn';
				default:
					return 'Text';
			}
		},
		editClient(item) {
			this.$router.push({
				name: 'ClientsManagementEdit',
				params: { id: item.Id },
			});
		},
		addClient() {
			this.$router.push({
				name: 'ClientsManagementAdd',
				params: { id: null },
			});
		},

		deleteClient(id) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this client?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$store
						.dispatch(ClientManagementActions.DELETE, id)
						.then(() => {
							this.getClients();
						});
				}
			});
		},
		onAddClientModalCancel() {
			this.showDialog = false;
		},
		onAddClientModalSubmit() {
			this.getClients();
			this.showDialog = false;
		},
	},
};
</script>
